<template>
  <div class="reiki">
    <app-header :background-name="'wallpaper2.jpg'">
      <h1>Stéphanie Lefebvre</h1>
      <h2>Présentation du Reiki</h2>
    </app-header>

    <div class="content">
      <div class="description">
        <p>Juste pour aujourd’hui, je me libère de toute <span>préoccupation.</span></p>
        <p>Juste pour aujourd’hui, je me libère de toute <span>colère.</span></p>
        <p>
          Juste pour aujourd’hui, je <span>rends grâce</span> pour mes nombreuses
          <span>bénédictions</span>, j’honore mes parents, mes professeurs et mes aïeux.
        </p>
        <p>Juste pour aujourd’hui, je <span>vis ma vie honnêtement.</span></p>
        <p>Juste pour aujourd’hui, je <span>respecte la vie</span> autour de moi sous toutes ses formes.</p>
      </div>
      <article>
        <img src="~@/assets/background/reiki.png" alt="flower" class="left">
        <div class="bloc">
          <h1>C'est quoi le Reiki ?</h1>
          <p>
            <span>Rei</span> signifie <span>« esprit »</span>. <b>Ki</b> signifie <span>« puissance »,
            « énergie », « force vitale »</span>, Il est donc possible de traduire le <span>Reiki</span>
            par <span>« Force Universelle »</span>, ou « Force de l’esprit ».
          </p>

          <p>
            Le <span>Reiki</span> est une <span>méthode de soins énergétiques</span>, d’origine japonaise,
            non conventionnelle, enseignée par Mikao Usui. Simple et naturelle,
            cette technique apporte un bien-être général tant sur le plan
            physique, qu’émotionnel, mental ou spirituel. Le Reiki est <span>doux et
            puissant, simple et efficace</span>.
          </p>

          <p>
            Pendant un soin Reiki, le praticien se met au service de l’énergie
            universelle et retransmet cette énergie bienfaisante au receveur, par
            les mains, et grâce à l’utilisation de symboles et de pensées
            bienveillantes. L’énergie va alors <span>circuler, stimuler, et rééquilibrer</span>
            les parties du corps qui en ont besoin.
          </p>

          <p>
            Le reiki permet donc de <span>réharmoniser les énergies intérieures</span>, de
            soulager les douleurs, de développer la confiance en soi et la
            capacité du corps à mobiliser ses propres forces vitales. Il permet
            plus de <span>relaxation, une diminution significative du stress, et apporte
            plus de clarté mentale et émotionnelle</span>.
          </p>

        </div>
        <img src="~@/assets/background/mikao.jpg" alt="flower" class="right">
        <div class="bloc">
          <p>Les effets bénéfiques du Reiki
            permettent une <span>réaction de bien-être en chaîne</span>, développant le
            potentiel d’auto-guérison du receveur.</p>
          <p>
            Une séance de soin Reiki débute par un temps d’échange. Puis le
            receveur, habillé, s’installe confortablement sur la table de soin. Il
            lui est juste demandé d’enlever ses chaussures, de ne pas croiser
            les membres, et de retirer ou de desserrer tout accessoire qui
            pourrait gêner la libre circulation de l’énergie (ceinture, bijou…) et de ne pas porter de vêtement en cuir.
          </p>

          <p>
            L’action de cette technique énergétique complémentaire peut, bien
            entendu, être utilisée conjointement avec le suivi du médecin traitant
            ou du spécialiste. En aucun cas, le Reiki ne se substitue aux
            traitements en cours. Le reiki vient en <span>complément</span>, afin de participer
            à un processus d’auto-guérison.
          </p>

          <p>
            Le praticien Reiki se doit d’ailleurs de rester <span>humble, respectueux</span>,
            et de maintenir, pour lui-même, une excellente hygiène énergétique,
            ceci grâce à des auto-traitements Reiki réguliers, et à la pratique de
            disciplines telles que la méditation, le Qi-Gong, le Tai-Chi.
          </p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/Header'

  export default {
    name: 'Reiki',
    components: { AppHeader }
  }
</script>

<style lang="scss" scoped>
  .reiki {
    display: flex;
    flex-direction: column;
    flex: 1;

    .content {
      position: relative;
      text-align: center;
      background-color: #f1fae7;
      align-items: center;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      @media screen and (max-width: 680px) {
        overflow: auto;
      }
      .description {
        width: 50%;
        margin: .5em;
        font-weight: 300;
        font-size: 1.1em;
        font-family: 'Delius', cursive;

        p {
          margin: .5em;

          &:last-child {
            margin-bottom: 0;
          }
        }

        span {
          color: $color-green;
          font-weight: 700;
        }
      }

      article {
        @include custom-article();
        img {
          position: absolute;
          z-index: 0;
          opacity: .5;

          &.left {
            bottom: 2vw;
            left: 4vw;
          }

          &.right {
            top: 8vw;
            right: 4vw;
            border-radius: 50%;
          }
        }
      }
    }
  }
</style>
